export default __webpack_public_path__ + "static/media/assets_images_logo.5541067e.png";